import { useContext } from "react";
import Header from "../Header";
import Navbar from "../Navbar";
import { Box, useTheme } from "@mui/material";
import { GlobalContext } from "../Context";

const Layout = ({ children, isLoggedIn }) => {
  const { signUp, notFound, optionState, mobileView, tabletView } =
    useContext(GlobalContext);
  const theme = useTheme();

  const masterContainerStyle = {
    width: "100%",
    minHeight: "100vh",
    backgroundColor: theme.palette.background.main,
  };

  const containerStyle = {
    overflowX: "hidden",
    overflowY:
      optionState.nav === "safeRoads" && (tabletView || mobileView)
        ? "scroll"
        : " hidden",
    width: !isLoggedIn || mobileView || tabletView ? "100%" : "90%",
    maxWidth:
      !isLoggedIn || optionState.nav === "safeRoads" ? "inherit" : "1400px",
    p: !isLoggedIn
      ? 0
      : mobileView || tabletView || optionState.nav === "safeRoads"
      ? "7rem 5% 3rem"
      : "6rem 1% 6rem 66px",
    m: "0 auto",
    zIndex: "-1",
  };

  return (
    <Box sx={masterContainerStyle}>
      {signUp || notFound ? (
        <>
          <Header />
        </>
      ) : !isLoggedIn ? (
        <></>
      ) : (
        <>
          <Header isLoggedIn={isLoggedIn} />
          {isLoggedIn && !tabletView && !mobileView && <Navbar />}
        </>
      )}
      <Box sx={containerStyle}>{children}</Box>
    </Box>
  );
};

export default Layout;
